import Box from "@material-ui/core/Box";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React, { ReactNode } from "react";
import { Color } from "../../theme";
import { HasChildren, HasTestId, PlainFunctionComponent } from "../../types";
import { isDefined } from "../../util";

export interface TableButtonBarProps extends HasChildren, HasTestId {
    className?: string;
    rightAlignedItems?: ReactNode;
    statusLabel?: ReactNode;
}

export const TableButtonBar: PlainFunctionComponent<TableButtonBarProps> = ({ children, className, rightAlignedItems, statusLabel, testId }) => {
    const classes = useStyles();
    return (
        <Box className={clsx(classes.tableButtonBar, className)} data-testid={testId}>
            <Box key="leftItems" className={classes.leftAlignedItemsContainer}>
                {children}
            </Box>
            {isDefined(statusLabel) ? (
                <Box key="status" className={classes.statusLabel}>
                    {statusLabel}
                </Box>
            ) : (
                <></>
            )}
            {isDefined(rightAlignedItems) ? (
                <Box key="rightItems" className={classes.rightAlignedItemsContainer}>
                    {rightAlignedItems}
                </Box>
            ) : (
                <></>
            )}
        </Box>
    );
};

const useStyles = makeStyles(
    createStyles({
        statusLabel: {
            color: Color.grey4,
            flex: 1,
            fontSize: 12,
            fontWeight: "bold",
            lineHeight: "12px",
            marginRight: 24,
            whiteSpace: "nowrap",
        },
        tableButtonBar: {
            alignItems: "center",
            display: "flex",
            borderBottom: `1px solid ${Color.grey3}`,
            borderTop: `1px solid ${Color.grey3}`,
        },
        leftAlignedItemsContainer: {
            paddingBottom: "16px",
            paddingRight: "24px",
            "& > *": {
                // no margin bottom due to usage in flex box and outside with difference on collapsing margins -> use in TableButtonBar with 16px paddingBottom
                margin: "16px 0 0 24px",
            },
        },
        rightAlignedItemsContainer: {
            padding: "0 0 16px",
            textAlign: "right",
            "& > *": {
                margin: "16px 24px 0 0",
            },
        },
    }),
);
